import { trust } from '../../content';

/** The platform facts a buyer checks first, each one we can point to. */
export function TrustFacts() {
  return (
    <dl className="grid gap-px overflow-hidden rounded-[18px] bg-bm-line ring-1 ring-bm-line sm:grid-cols-2">
      {trust.facts.map((f) => (
        <div key={f.k} className="bg-white p-6 sm:p-7">
          <dt className="text-[14px] font-medium text-bm-muted">{f.k}</dt>
          <dd className="mt-2 text-[clamp(19px,1.7vw,23px)] font-bold leading-snug tracking-[-0.02em] text-bm-indigo">{f.v}</dd>
        </div>
      ))}
    </dl>
  );
}
